
export default function SolutionsSection() {
  const solutions = [
    {
      icon: 'ri-smartphone-line',
      title: 'Desenvolvimento Mobile',
      description: 'Aplicativos nativos e híbridos para iOS e Android com performance excepcional e design intuitivo.',
      features: ['React Native', 'Flutter', 'iOS/Android Nativo', 'PWA'],
      color: 'from-blue-500 to-cyan-500',
      image: 'https://readdy.ai/api/search-image?query=modern%20mobile%20app%20development%20workspace%20with%20smartphones%20and%20tablets%20displaying%20beautiful%20interfaces%2C%20blue%20and%20purple%20color%20scheme%2C%20professional%20developer%20environment%2C%20Santo%20Andr%C3%A9%20tech%20company&width=400&height=300&seq=mobile-dev&orientation=landscape'
    },
    {
      icon: 'ri-global-line',
      title: 'Desenvolvimento Web',
      description: 'Sites e sistemas web responsivos, rápidos e otimizados para conversão e experiência do usuário.',
      features: ['React/Next.js', 'Vue.js', 'Node.js', 'E-commerce'],
      color: 'from-purple-500 to-pink-500',
      image: 'https://readdy.ai/api/search-image?query=modern%20web%20development%20setup%20with%20multiple%20monitors%20showing%20responsive%20websites%2C%20clean%20code%20editor%2C%20blue%20purple%20gradient%20lighting%2C%20professional%20workspace%20in%20Santo%20Andr%C3%A9&width=400&height=300&seq=web-dev&orientation=landscape'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Sistemas Corporativos',
      description: 'ERPs, CRMs e sistemas de gestão personalizados para otimizar processos empresariais.',
      features: ['ERP Customizado', 'CRM', 'BI/Analytics', 'Integração APIs'],
      color: 'from-green-500 to-teal-500',
      image: 'https://readdy.ai/api/search-image?query=corporate%20business%20system%20dashboard%20with%20charts%20and%20analytics%2C%20modern%20office%20environment%2C%20professional%20business%20software%20interface%2C%20blue%20and%20green%20color%20scheme&width=400&height=300&seq=corp-systems&orientation=landscape'
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud & DevOps',
      description: 'Migração para nuvem, infraestrutura escalável e automação de processos de desenvolvimento.',
      features: ['AWS/Azure', 'Docker/Kubernetes', 'CI/CD', 'Monitoramento'],
      color: 'from-orange-500 to-red-500',
      image: 'https://readdy.ai/api/search-image?query=cloud%20computing%20infrastructure%20visualization%20with%20servers%20and%20network%20connections%2C%20modern%20data%20center%2C%20blue%20and%20orange%20lighting%2C%20technology%20concept%20art&width=400&height=300&seq=cloud-devops&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Segurança Digital',
      description: 'Auditoria de segurança, implementação de protocolos e proteção contra ameaças digitais.',
      features: ['Auditoria de Segurança', 'Criptografia', 'Backup/Recovery', 'Compliance'],
      color: 'from-indigo-500 to-purple-500',
      image: 'https://readdy.ai/api/search-image?query=cybersecurity%20concept%20with%20digital%20locks%20and%20shields%2C%20secure%20network%20visualization%2C%20blue%20and%20purple%20neon%20lighting%2C%20professional%20security%20operations%20center&width=400&height=300&seq=security&orientation=landscape'
    },
    {
      icon: 'ri-robot-line',
      title: 'Inteligência Artificial',
      description: 'Soluções de IA e Machine Learning para automação inteligente e análise preditiva.',
      features: ['Machine Learning', 'Chatbots', 'Análise Preditiva', 'Automação'],
      color: 'from-cyan-500 to-blue-500',
      image: 'https://readdy.ai/api/search-image?query=artificial%20intelligence%20and%20machine%20learning%20visualization%20with%20neural%20networks%20and%20data%20flows%2C%20futuristic%20blue%20and%20cyan%20lighting%2C%20AI%20technology%20concept&width=400&height=300&seq=ai-ml&orientation=landscape'
    }
  ];

  return (
    <section id="solucoes" className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-800 to-slate-900"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-40 left-10 w-72 h-72 bg-blue-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-40 right-10 w-64 h-64 bg-purple-500/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 container mx-auto px-6">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full text-blue-300 text-sm font-medium mb-6">
            <i className="ri-lightbulb-line mr-2"></i>
            Nossas Soluções
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            <span className="gradient-text-primary">Soluções Tecnológicas</span> Completas
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Oferecemos <strong className="text-blue-300">desenvolvimento de software personalizado</strong> e 
            <strong className="text-purple-300"> consultoria especializada em TI</strong> para empresas que buscam 
            <strong className="text-cyan-300"> inovação e transformação digital</strong>, com foco em resultados excepcionais.
          </p>
        </div>

        {/* Solutions grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className="glass-card p-6 rounded-2xl card-hover group relative overflow-hidden"
            >
              {/* Background image */}
              <div className="absolute inset-0 opacity-20 group-hover:opacity-30 transition-opacity duration-300">
                <img 
                  src={solution.image}
                  alt={`${solution.title} - MPG System Santo André`}
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Content */}
              <div className="relative z-10">
                <div className={`w-14 h-14 bg-gradient-to-r ${solution.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${solution.icon} text-white text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-4">{solution.title}</h3>
                <p className="text-white/80 text-sm leading-relaxed mb-6">{solution.description}</p>
                
                {/* Features */}
                <div className="space-y-2 mb-6">
                  {solution.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-sm">
                      <i className="ri-check-line text-blue-400 mr-2"></i>
                      <span className="text-white/70">{feature}</span>
                    </div>
                  ))}
                </div>
                
                <button 
                  onClick={() => {
                    const element = document.getElementById('contato');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full bg-white/10 hover:bg-white/20 border border-white/20 hover:border-white/30 text-white py-3 px-4 rounded-xl transition-all duration-300 font-medium"
                >
                  Saiba Mais
                  <i className="ri-arrow-right-line ml-2"></i>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Process section */}
        <div className="glass-card p-8 md:p-12 rounded-3xl">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">
              Nosso Processo de <span className="gradient-text-primary">Desenvolvimento</span>
            </h3>
            <p className="text-white/80 max-w-2xl mx-auto">
              Seguimos uma metodologia ágil e transparente para garantir a entrega de 
              <strong className="text-blue-300"> soluções de alta qualidade</strong> dentro do prazo e orçamento.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: 'Análise',
                description: 'Entendemos suas necessidades e objetivos de negócio',
                icon: 'ri-search-line',
                color: 'from-blue-500 to-cyan-500'
              },
              {
                step: '02',
                title: 'Planejamento',
                description: 'Criamos a estratégia e arquitetura da solução',
                icon: 'ri-draft-line',
                color: 'from-purple-500 to-pink-500'
              },
              {
                step: '03',
                title: 'Desenvolvimento',
                description: 'Codificamos com as melhores práticas e tecnologias',
                icon: 'ri-code-s-slash-line',
                color: 'from-green-500 to-teal-500'
              },
              {
                step: '04',
                title: 'Entrega',
                description: 'Testamos, implantamos e oferecemos suporte contínuo',
                icon: 'ri-rocket-line',
                color: 'from-orange-500 to-red-500'
              }
            ].map((process, index) => (
              <div key={index} className="text-center group">
                <div className={`w-16 h-16 bg-gradient-to-r ${process.color} rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${process.icon} text-white text-2xl`}></i>
                </div>
                <div className="text-2xl font-bold text-white/40 mb-2">{process.step}</div>
                <h4 className="text-lg font-semibold text-white mb-3">{process.title}</h4>
                <p className="text-white/70 text-sm leading-relaxed">{process.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <div className="glass-card p-8 rounded-2xl max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-white mb-4">
              Precisa de uma Solução Personalizada?
            </h3>
            <p className="text-white/80 mb-6">
              Nossa equipe de especialistas em <strong className="text-blue-300">desenvolvimento de software</strong> está 
              pronta para criar a solução perfeita para sua empresa em <strong className="text-purple-300">Santo André</strong>.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => {
                  const element = document.getElementById('contato');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="btn-primary"
              >
                <i className="ri-phone-line mr-2"></i>
                Solicitar Orçamento
              </button>
              <button 
                onClick={() => {
                  const element = document.getElementById('produtos');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="btn-secondary"
              >
                <i className="ri-eye-line mr-2"></i>
                Ver Produtos
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
